export const getQueryParam = param => {
  // Accessing `window.top` throws when we're on a
  // different domain (e.g. Wordpress)
  try {
    const searchParams = new URLSearchParams(window.top.location.search);
    return searchParams.get(param) || '';
  } catch (_) {
    return '';
  }
};